import { Component, OnInit, Input } from '@angular/core';
import { NewsArticle } from 'src/app/interfaces/interfaces';
import { ApiService } from 'src/app/services/api-services/api.service';
import { DatetimeFormatService } from 'src/app/services/datetime-format-service/datetime-format.service';

@Component({
  selector: 'app-portal-feed',
  templateUrl: './portal-feed.component.html',
  styleUrls: ['./portal-feed.component.scss'],
})
export class PortalFeedComponent implements OnInit {
  newsArticles: NewsArticle[] = [];
  loading = false;
  publishDateToDisplay: Date;
  locale = this.datetimeFormatService.selectedDateTimeFormat;
  constructor(public apiService: ApiService, private datetimeFormatService: DatetimeFormatService) {}

  ngOnInit() {
    this.getNewsArticles();
  }


  getNewsArticles() {
    this.loading = true;
    this.apiService.getOrganisationNewsArticles().subscribe((res) => {
      // replace <p> with <span> and </p> with </span> to remove the margin and padding from <p> tags
      res.forEach((item) => {
        item.text = item.text
          .replace('<p>', '<span>')
          .replace('</p>', '</span>');
      });
      this.newsArticles = res;
      this.publishDateToDisplay = this.newsArticles[0]?.publishDate;
      this.loading = false;
    });
  }

  onSlideChange(event: any) {
    const swiper = event.detail[0]
    this.publishDateToDisplay = this.newsArticles[swiper.activeIndex]?.publishDate;
  }
}
